import React from 'react';
import { AddressFormData } from '../../../types/Address';

export type AddressSummaryProps = {
  address: AddressFormData;
  displayAddressType?: boolean;
};

const AddressSummary: React.FC<AddressSummaryProps> = ({
  address,
  displayAddressType = false,
}: AddressSummaryProps) => {
  return (
    <div className="flex flex-col content-start text-sm">
      <div>{`${address.firstName} ${address.lastName}`}</div>
      <div>
        {address.address2
          ? `${address.address1} ${address.address2}`
          : address.address1}
      </div>
      <div>{`${address.city}, ${address.state} ${address.postalCode}`}</div>
      <div>{address.country}</div>
      {displayAddressType && (
        <div>
          {address.residential === true ? '(Residential)' : '(Business)'}
        </div>
      )}
    </div>
  );
};

export default AddressSummary;
